import { Scrollbar } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { TabContext } from '@mui/lab';
import { Box } from '@mui/material';
import { memo } from 'react';
import { useGetNotificationTabItems } from '../../hooks/use-get-notification-tab-items';
import { useNotificationStore } from '../../store';
import { NotificationStatus } from '../../types';
import { config } from './config';
import { NotificationPanel } from './notification-panel';
import { NotificationTab } from './notification-tab';
import * as Styled from './styles';
import * as SX from './sx';
import { type NotificationTabsProps as Props } from './types';

export const NotificationTabs = memo(({ className }: Props) => {
  const notificationTab = useNotificationStore.useNotificationTab();
  const containerRef = useNotificationStore.useContainerRef();
  const handleScroll = useNotificationStore.useHandleScroll();
  const notifications = useNotificationStore.useNotifications();
  const setNotificationTab = useNotificationStore.useSetNotificationTab();
  const { all, sent } = useGetNotificationTabItems(notifications);

  return (
    <TabContext value={notificationTab}>
      <Box sx={SX.tabsWrapper}>
        <Styled.Wrapper
          className={classnames('NotificationTabs', className)}
          sx={SX.root}
          value={notificationTab}
          key={notificationTab}
          size="medium"
          onChange={(_, v) => setNotificationTab(v)}
        >
          {config.map(({ label, value, disabled }) => (
            <NotificationTab
              key={value}
              label={label}
              value={value}
              disabled={disabled}
            />
          ))}
        </Styled.Wrapper>
      </Box>

      <Scrollbar sx={SX.scrollbar} ref={containerRef} onScroll={handleScroll}>
        <Box
          sx={SX.tabContent}
          className={classnames('NotificationTabs-Content', className)}
        >
          {notificationTab === NotificationStatus.ALL && (
            <NotificationPanel value={NotificationStatus.ALL} items={all} />
          )}
          {notificationTab === NotificationStatus.SENT && (
            <NotificationPanel value={NotificationStatus.SENT} items={sent} />
          )}
        </Box>
      </Scrollbar>
    </TabContext>
  );
});

NotificationTabs.displayName = 'NotificationTabs';
